import script from "./NotificacaoComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificacaoComponent.vue?vue&type=script&setup=true&lang=ts"

import "./NotificacaoComponent.vue?vue&type=style&index=0&id=180eda82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180eda82"]])

export default __exports__